import { useEffect, useState } from 'react';

import { useSelector } from 'react-redux';
import { selectMediaQuery } from 'store/selectors';

function useBlockBodyScroll(block: boolean) {
  const mediaQuery = useSelector(selectMediaQuery);
  const [bodyEl, setBodyEl] = useState<HTMLBodyElement | null>(null);

  useEffect(() => {
    const element = document?.querySelector('body');
    setBodyEl(element);
  }, []);

  useEffect(() => {
    if (!bodyEl || !mediaQuery.md) {
      return;
    }

    bodyEl.style.setProperty('overflow', block ? 'hidden' : 'auto');
    bodyEl.style.setProperty('position', block ? 'fixed' : 'initial');

    return () => {
      bodyEl.style.setProperty('overflow', 'auto');
      bodyEl.style.setProperty('position', 'initial');
    };
  }, [block, bodyEl, mediaQuery.md]);
}

export default useBlockBodyScroll;
